var ie = (typeof document.selection != "undefined" && document.selection.type != "Control") && true;
var w3 = (typeof window.getSelection != "undefined") && true;


function DivEditable() {
}

DivEditable.prototype.getCaretPosition = function (element) {
  var caretOffset = 0;
  if (w3) {
    var range = window.getSelection().getRangeAt(0);
    var preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    caretOffset = preCaretRange.toString().length;
  } else if (ie) {
    var textRange = document.selection.createRange();
    var preCaretTextRange = document.body.createTextRange();
    preCaretTextRange.moveToElementText(element);
    preCaretTextRange.setEndPoint("EndToEnd", textRange);
    caretOffset = preCaretTextRange.text.length;
  }
  return caretOffset;
}


DivEditable.prototype.placeCaretAtEnd=function(el,moveTo){
  el.focus()
  if (typeof window.getSelection != "undefined"
          && typeof document.createRange != "undefined") {
      let range = document.createRange()
      // range.selectNodeContents(el)
      range.setStartBefore(moveTo) //this does the trick
      range.collapse(false)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
  }
}
DivEditable.prototype._insertAtCursor = function (field, value, selectPastedContent) {
  // value = '<img class="emoji_icon" src="assets/images/emoji/smi_sad.png"/>';
  var sel, range;
  if (field.nodeName === 'DIV') {
    field.focus();
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        var el = document.createElement('div');
        el.innerHTML = value;
        var frag = document.createDocumentFragment(), node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        var firstNode = frag.firstChild;
        range.insertNode(frag);

        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          if (selectPastedContent) {
            range.setStartBefore(firstNode);
          } else {
            range.collapse(true);
          }
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    } else if ((sel = document.selection) && sel.type !== 'Control') {
      var originalRange = sel.createRange();
      originalRange.collapse(true);
      sel.createRange().pasteHTML(value);
      if (selectPastedContent) {
        range = sel.createRange();
        range.setEndPoint('StartToStart', originalRange);
        range.select();
      }
    }
  } else {
    if (document.selection) {
      field.focus();
      sel = document.selection.createRange();
      sel.text = value;
      sel.select();
    }
    else if (field.selectionStart || field.selectionStart === 0) {
      var startPos = field.selectionStart;
      var endPos = field.selectionEnd;
      var restoreTop = field.scrollTop;
      field.value = field.value.substring(0, startPos) + value + field.value.substring(endPos, field.value.length);
      if (restoreTop > 0) {
        field.scrollTop = restoreTop;
      }
      field.focus();
      field.selectionStart = startPos + value.length;
      field.selectionEnd = startPos + value.length;
    } else {
      field.value += value;
      field.focus();
    }
  }

}


DivEditable.prototype.removeTextBeforeCursor = function (textLength) {
  try {
    if (window.getSelection()) {
      var sel = window.getSelection();
      for (var i = 0; i < textLength; i++) {
        sel.modify("extend", "backward", "character");
      }
      range = sel.getRangeAt(0);
      range.deleteContents();
    }
    
  } catch (error) {
    
  }

}

DivEditable.prototype.getCaretPosition1 = function (editableDiv) {
  var caretPos = 0,
    sel, range;
  if (window.getSelection) {
    sel = window.getSelection();
    if (sel.rangeCount) {
      range = sel.getRangeAt(0);
      // if (range.commonAncestorContainer.parentNode == editableDiv) {
      caretPos = range.endOffset;
      // }
    }
  } else if (document.selection && document.selection.createRange) {
    range = document.selection.createRange();
    if (range.parentElement() == editableDiv) {
      var tempEl = document.createElement("span");
      editableDiv.insertBefore(tempEl, editableDiv.firstChild);
      var tempRange = range.duplicate();
      tempRange.moveToElementText(tempEl);
      tempRange.setEndPoint("EndToEnd", range);
      caretPos = tempRange.text.length;
    }
  }
  return caretPos;
}

DivEditable.prototype.getCaretCharacterOffsetWithin=function(element){
  let caretOffset = 0;
  let doc = element.ownerDocument || element.document;
  let win = doc.defaultView || doc.parentWindow;
  let sel;
  if (typeof win.getSelection != "undefined") {
      sel = win.getSelection();
      if (sel.rangeCount > 0) {
          let range = win.getSelection().getRangeAt(0);
          let preCaretRange = range.cloneRange();
          preCaretRange.selectNodeContents(element);
          preCaretRange.setEnd(range.endContainer, range.endOffset);
          caretOffset = preCaretRange.toString().length;
      }
  } else if ( (sel = doc.selection) && sel.type != "Control") {
      let textRange = sel.createRange();
      let preCaretTextRange = doc.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint("EndToEnd", textRange);
      caretOffset = preCaretTextRange.text.length;
  }
  return caretOffset;
}

DivEditable.prototype.setCaretPosition1=function(element,position){
  const range = document.createRange();
	const selection = window.getSelection();

	//select appropriate node
	let currentNode = null;
	let previousNode = null;

	for (let i = 0; i < element.childNodes.length; i++) {
		//save previous node
		previousNode = currentNode;

		//get current node
		currentNode = element.childNodes[i];
		//if we get span or something else then we should get child node
		while (currentNode.childNodes.length > 0) {
			currentNode = currentNode.childNodes[0];
		}

		//calc offset in current node
		if (previousNode != null) {
			position -= previousNode.length;
		}
		//check whether current node has enough length
		if (position <= currentNode.length) {
			break;
		}
	}
	//move caret to specified offset
	if (currentNode != null) {
		range.setStart(currentNode, position);
		range.collapse(true);
		selection.removeAllRanges();
		selection.addRange(range);
	}
}
DivEditable.prototype.pasteHtmlAtCaret = function () {
  html = '<img src="https://lh3.googleusercontent.com/-DZCpQxab1do/AAAAAAAAAAI/AAAAAAAAAAA/AAnnY7rTy7IyeC35_ZvbrSQUOcTvcZ6etw/s32-c-mo/photo.jpg" />';
  var sel, range;
  if (window.getSelection) {
    // IE9 and non-IE
    sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();

      // Range.createContextualFragment() would be useful here but is
      // non-standard and not supported in all browsers (IE9, for one)
      var el = document.createElement("div");
      el.innerHTML = html;
      var frag = document.createDocumentFragment(), node, lastNode;
      while ((node = el.firstChild)) {
        lastNode = frag.appendChild(node);
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type != "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}


function getCaretHTMLBegin(element) {
  var caretOffset = 0;
  if (w3) {
    var range = window.getSelection().getRangeAt(0);
    var preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.beginOffset);
    caretOffset = preCaretRange.toString().length;
  } else if (ie) {
    caretOffset = 'n/a';
  }
  return caretOffset;
}

function getCaretBegin(element) {
  var caretOffset = 0;
  if (w3) {
    var range = window.getSelection().getRangeAt(0);
    var preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.beginOffset);
    caretOffset = preCaretRange.toString().length;
  } else if (ie) {
    var textRange = document.selection.createRange();
    var preCaretTextRange = document.body.createTextRange();
    preCaretTextRange.moveToElementText(element);
    preCaretTextRange.setEndPoint("EndToStart", textRange);
    caretOffset = preCaretTextRange.text.length;
  }
  return caretOffset;
}

function getSelectionBegin(element) {
  var caretOffset = 0;
  if (w3) {
  }
  else if (ie) {
    var textRange = document.selection.createRange();
    var preCaretTextRange = document.body.createTextRange();
    preCaretTextRange.moveToElementText(element);
    preCaretTextRange.setEndPoint("EndToStart", textRange);
    caretOffset = preCaretTextRange.text.length;
  }
  return caretOffset;
}

function getSelectedRange(element) {
  var selection = {
    position: 'n/a',
    begin: 'n/a',
    end: 'n/a',
    size: 'n/a',
    htmlBegin: 'n/a',
    htmlEnd: 'n/a',
    wordBegin: 'n/a',
    wordEnd: 'n/a'
  };
  if (ie) {
    var textRange = document.selection.createRange();
    var preCaretTextRange = document.body.createTextRange();
    preCaretTextRange.moveToElementText(element);
    preCaretTextRange.setEndPoint("EndToEnd", textRange);
    selection.end = preCaretTextRange.text.length;

    preCaretTextRange.moveToElementText(element);
    preCaretTextRange.setEndPoint("EndToStart", textRange);
    selection.begin = preCaretTextRange.text.length;
    selection.size = selection.end - selection.begin;
  }
  return selection;
}

DivEditable.prototype.getCurrentWord = function (el, position) {
  let currentWord = "";
  try {
    let content = el.textContent;
    if (content[position] === ' ' || content[position] == String.fromCharCode(160)) {
      return "";
    }
    var startPosition = content.lastIndexOf(' ', position);
    var startPosition1 = content.lastIndexOf(String.fromCharCode(160), position);
    startPosition = (startPosition > startPosition1)? startPosition : startPosition1;
    var endPosition = content.indexOf(' ', position);
    var endPosition1 = content.indexOf(String.fromCharCode(160), position);
    endPosition = (endPosition > endPosition1)? endPosition : endPosition1;
    if (position == startPosition){
      return "";
    }
    startPosition = startPosition === content.length ? 0 : startPosition;
    endPosition = endPosition === -1 ? content.length : endPosition;
    return content.substring(startPosition + 1, endPosition);

  } catch (error) {

  }
  return currentWord;

}

function node_walk(node, func) {
  var result = func(node);
  for(node = node.firstChild; result !== false && node; node = node.nextSibling)
    result = node_walk(node, func);
  return result;
};


DivEditable.prototype.getCurrentCaretPosition = function (elem) {
  var sel = window.getSelection();
  var cum_length = [0, 0];

  if(sel.anchorNode == elem)
    cum_length = [sel.anchorOffset, sel.extentOffset];
  else {
    var nodes_to_find = [sel.anchorNode, sel.extentNode];
    if(!elem.contains(sel.anchorNode) || (!elem.contains(sel.extentNode) && !elem.contains(sel.focusNode)))
      return undefined;
    else {
      var found = [0,0];
      var i;
      node_walk(elem, function(node) {
        for(i = 0; i < 2; i++) {
          if(node == nodes_to_find[i]) {
            found[i] = true;
            if(found[i == 0 ? 1 : 0])
              return false; // all done
          }
        }

        if(node.textContent && !node.firstChild) {
          for(i = 0; i < 2; i++) {
            if(!found[i])
              cum_length[i] += node.textContent.length;
          }
        }
      });
      cum_length[0] += sel.anchorOffset;
      if(sel.extentOffset){
        cum_length[1] += sel.extentOffset;
      } else {
        cum_length[1] += sel.focusOffset;
      }
    }
  }
  if(cum_length[0] <= cum_length[1])
    return cum_length;
  return [cum_length[1], cum_length[0]];
}

function showCaretDiv() {
  var el = $("#test").get(0);
  $('#caretPos').html(getCaretPosition(el));
  $('#caretBegin').html(getSelectionBegin(el));
  $('#caretEnd').html(getCaretPosition(el));
  $('#htmlBegin').html(getCaretHTMLBegin(el));
  $('#htmlEnd').html(getCaretHTMLBegin(el));
  $('#wordBegin').html(getCaretHTMLBegin(el));
}

function showCaretTextarea() {
  var sel = getSelectedRange($("#test2").get(0));
  $('#caretPos2').html(sel.position);
  $('#caretBegin2').html(sel.begin);
  $('#caretEnd2').html(sel.end);
  $('#caretSize2').html(sel.size);
  $('#wordBegin2').html(sel.wordBegin);
}


// $('#test').keyup(showCaretDiv);
// $('#test').mouseup(showCaretDiv);
// $('#test2').keyup(showCaretTextarea);
// $('#test2').mouseup(showCaretTextarea);
